// @flow
import type { User } from '../types';
import { CALL_API } from '../middlewares/api';
import * as constants from '../constants/userConstants';

type FetchUsersAction = {|
    type: typeof constants.FETCH_USERS,
    [CALL_API]: {
        method: 'GET',
        endpoint: '/api/user'
    }
|};

type LoggingInAction = {|
    type: typeof constants.LOGGING_IN,
    data: boolean
|};

type SetUserAction = {|
    type: typeof constants.SET_USER,
    data: User
|};

type CreateUserAction = {|
    type: typeof constants.CREATE_USER,
    [CALL_API]: {
        method: 'POST',
        endpoint: '/api/user',
        data: User
    }
|};

type UpdateUserAction = {|
    type: typeof constants.UPDATE_USER,
    [CALL_API]: {
        method: 'PUT',
        endpoint: '/api/user',
        data: User
    }
|};

export type UserAction =
    | FetchUsersAction
    | LoggingInAction
    | SetUserAction
    | CreateUserAction
    | UpdateUserAction;

const userActions = {
    fetchUsers: (): FetchUsersAction => ({
        type: constants.FETCH_USERS,
        [CALL_API]: {
            method: 'GET',
            endpoint: '/api/user'
        }
    }),

    loggingIn: (finished?: boolean = false): LoggingInAction => ({
        type: constants.LOGGING_IN,
        data: finished
    }),

    setUser: (user: null | User): SetUserAction => ({
        type: constants.SET_USER,
        data: user
    }),

    createUser: (user: User): CreateUserAction => ({
        type: constants.CREATE_USER,
        [CALL_API]: {
            method: 'POST',
            endpoint: '/api/user',
            data: user
        }
    }),

    updateUser: (user: User): UppdateUserAction => ({
        type: constants.UPDATE_USER,
        [CALL_API]: {
            method: 'PUT',
            endpoint: `/api/user/${user.uid}`,
            data: user
        }
    })
};

export default userActions;